import Stardust from "../../images/about-us/stardust.png";
import Stardust1 from "../../images/about-us/stardust1.png";
import AboutImage from "../../images/about-us/about-bg-image.png";
import AboutHeading from "../../images/about-us/about-heading.png";
import Vector from "../../images/about-us/Vector.png";
import Vector3 from "../../images/about-us/Vector 3.png";
import Vector4 from "../../images/about-us/Vector 4.png";

function AboutComponent() {
  return (
    <div className="about-us-about">
      <img src={Stardust} alt="stardust" className="about-stardust" />
      <img src={Stardust1} alt="stardust" className="about-stardust1" />
      <img src={AboutImage} alt="bg" className="bg-image" />
      <div className="heading">
        <img src={AboutHeading} alt="bg" />
        <h1>Inside Brandone</h1>
        <p>
          Founded in 2013,{" "}
          <span style={{ fontWeight: "bold" }}>BrandOne Technologies Ltd</span>{" "}
          is a notable provider of vendor-independent enterprise solutions. We
          help businesses translate their goals into effective IT services,
          using our proprietary project management framework and tools to
          maximize ROI. With over 15 years of hands-on experience, our certified
          professionals bring deep expertise in enterprise application design,
          system integration, and customer service. We identified a gap in
          enterprise web solutions — and we're filling it with smart, reliable
          delivery. Built on trust, quality, and strong relationships, we value
          openness, collaboration, and delivering real value to every client.
        </p>
      </div>
      <div className="info">
        <div className="philosophy">
          <img src={Vector3} alt="vector" className="vector3" />
          <img src={Vector4} alt="vector" className="vector4" />
          <h2>Corporate Philosophy</h2>
          <p>
            Our corporate philosophy establishes the fundamental principles of
            our management system. Our worldwide operational and performance
            standards translate the corporate values into specific management
            expectations. We preserve a high level of business ethics
            characterized by integrity and honesty in all our business actions.
          </p>
        </div>
        <div className="projects">
          <img src={Vector} alt="vector" className="vector" />
          <div>
            <p>30+ Projects</p>
            <p>40+ Team mates</p>
            <p>20+ Partners</p>
            <p>30+ Clients</p>
            <p>30+ Projects</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutComponent;
